import React from 'react'
import "./investor.css"

const Investor = () => {
  return (
    <div className='investor mt-10 sm:mt-14 lg:mt-0 py-10'>
        <div className='investor__container container mx-auto flex justify-center items-center flex-col'>
          <div className='sm:w-3/4 lg:w-3/4 xl:w-3/5 my-5 sm:my-10 px-5 sm:px-0  2xl:px-10 relative z-10'>
            <div className='investor__para text-center'>
              <span className='block'>TriMorphix stands out because we offer an<span className='investor-para__yello'> end-to-end digital solution </span>under one roof</span>
              <span className='block mt-4'>From design to development to marketing, we align every service with your brand goals to create cohesive, conversion-focused digital experiences</span>
            </div>
            <div className='grid md:grid-cols-2 mt-5'>
              <div className='flex flex-col gap-3'>
                <span className='text-[#fff] block text-base font-nomral text-center'>Dedicated in-house team of experts</span>
                <span className='text-[#fff] block text-base font-nomral text-center'>Client-centric, agile workflow</span>
                <span className='text-[#fff] block text-base font-nomral text-center'>Competitive pricing without compromising quality</span>
              </div>
              <div className='flex flex-col gap-3'>
                <span className='text-[#fff] block text-base font-nomral text-center'>Transparent communication</span>
                <span className='text-[#fff] block text-base font-nomral text-center'>Proven strategies backed by analytics</span>
                <span className='text-[#fff] block text-base font-nomral text-center'>We’re not just a service provider—we're your digital growth partner</span>
              </div>
            </div>
            <span className='solution__title text-center block mb-10 mt-10 lg:mt-0'>Why Choose Us</span>
            <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3'>
              <div className='bg-[rgba(0,0,0,0.5)] p-5 rounded-lg'>
                <span className='text-[#FED21B] block mb-3 text-lg'>Customized Techniques</span>
                <span className='text-[#fff] text-[15px]'>Customized technique for every business</span>
              </div>
              <div className='bg-[rgba(0,0,0,0.5)] p-5 rounded-lg'>
                <span className='text-[#FED21B] block mb-3 text-lg'>Real-Time Analytics</span>
                <span className='text-[#fff] text-[15px]'>Real-time analytics and transparent reporting</span>
              </div>
              <div className='bg-[rgba(0,0,0,0.5)] p-5 rounded-lg'>
                <span className='text-[#FED21B] block mb-3 text-lg'>Cost-Effective Packages</span>
                <span className='text-[#fff] text-[15px]'>Cost-effective packages that fit your budget</span>
              </div>
              <div className='bg-[rgba(0,0,0,0.5)] p-5 rounded-lg'>
                <span className='text-[#FED21B] block mb-3 text-lg'>Dedicated Account Managers</span>
                <span className='text-[#fff] text-[15px]'>Committed Account Managers</span>
              </div>
              <div className='bg-[rgba(0,0,0,0.5)] p-5 rounded-lg'>
                <span className='text-[#FED21B] block mb-3 text-lg'>100% Ethical Practices</span>
                <span className='text-[#fff] text-[15px]'>White-hat and 100% ethical practices</span>
              </div>
              <div className='bg-[rgba(0,0,0,0.5)] p-5 rounded-lg'>
                <span className='text-[#FED21B] block mb-3 text-lg'>Transparent Reporting</span>
                <span className='text-[#fff] text-[15px]'>Transparent reporting & Real-Time results</span>
              </div>
            </div>
          </div>
          <div className='investor__btn grid place-content-center'>
            <button> Connect with Us </button>
          </div>
        </div>
    </div>
  )
}

export default Investor